import React from 'react';

import Context                  from '../../../../../../../../context';
import convertNumberToPrice     from '../../../../../../../../utils/convertNumberToPrice';
import convertGregorianToJalali from '../../../../../../../../utils/convertGregorianToJalali';

import {
  CustomIcon,
  TableNullData,
  UserInformation,
} from '../../../../../../../../components';

import './index.scss';

type Props = {
  data: any;
};

const Body: React.FC<Props> = (porps: Props): React.ReactElement => {

  const { requestApproveParentTransaction, setSelectedPayment, setShowModal } = React.useContext(
    Context.ApproveParentTransactionScreen
  );
  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = porps?.data?.data?.result?.docs;


  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickRow(index: number): void {
    setSelectedPayment(index);
    setShowModal("SHOW_INFO");
  }

  function approveOnClickHandler(selectedItem: any): void {
    setSelectedPayment(selectedItem);
     setShowModal("APPROVE_PARENT_TRANSACTION_MODAL");
  }

  function cancelOnClickHandler(selectedItem: any): void {
    setSelectedPayment(selectedItem);
     setShowModal("CANCEL_PARENT_TRANSACTION_MODAL");
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="find-transaction-body-container">
        {docs?.map((debt: any, index: number) => {
          return (
            <tr key={`files-tr-${index}`}>
              <td onClick={() => onClickRow(index)}>
                <div className="table-index-number">
                  {requestApproveParentTransaction.page === 1
                    ? index + 1 : (requestApproveParentTransaction.page - 1) * 10 + index + 1}
                </div>
              </td>
              <td onClick={() => onClickRow(index)}>
                <UserInformation
                  name={debt?.parent?.firstName + " " + debt?.parent?.lastName}
                  phoneNumber={debt?.parent?.phoneNumber}
                  hideAvatar
                />
              </td>
              <td onClick={() => onClickRow(index)}>
                <UserInformation
                  avatar={debt?.student?.avatar}
                  name={debt?.student?.firstName + " " + debt?.student?.lastName}
                />
              </td>
              <td onClick={() => onClickRow(index)}>
                <UserInformation
                  avatar={debt?.driver?.avatar}
                  name={debt?.driver?.firstName + " " + debt?.driver?.lastName}
                  phoneNumber={debt?.driver?.phoneNumber}
                />
              </td>
              <td onClick={() => onClickRow(index)}>{convertNumberToPrice(debt?.price)} {"تومان"}</td>
              <td onClick={() => onClickRow(index)}>
                {convertGregorianToJalali({
                  date: debt?.updatedAt,
                  format: "hh:mm  jYYYY/jMM/jDD ",
                })}
              </td>
              <td onClick={() => onClickRow(index)} className="table-text">
                {debt?.isOnline ? "آنلاین" : "آفلاین"}
              </td>
              <td className="table-text">
                <div className="table-actions-buttons">
                  <CustomIcon
                    icon="fa-solid fa-check"
                    hoverTitle={"تایید"}
                    onClick={() => approveOnClickHandler(debt)}
                  />
                  <CustomIcon
                    icon="fa-solid fa-ban"
                    hoverTitle={"رد"}
                    onClick={() => cancelOnClickHandler(debt)}
                  />
                </div>
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Body;
